import { useSelector } from 'react-redux';

import { useBreakpointsContext } from '@air/provider-media-query';

import { Routes } from '~/constants/routes';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';
import { usePrivateSearchContext } from '~/providers/PrivateSearchProvider';
import { similarToImageFilterSelector } from '~/store/filters/selectors';

export const usePrivateSearchUIHelpers = () => {
  const { isSearchActive } = useIsSearchActive();
  const { searchType, canUseSmartSearch } = usePrivateSearchContext();
  const { isAboveMediumScreen } = useBreakpointsContext();
  const { isActiveRoute: isOnAllPage } = useIsActiveRoute({ route: Routes.media.all });

  // Read from Redux for similarToImage (not in URL due to base64 size)
  const similarToImage = useSelector(similarToImageFilterSelector);

  // Read from URL for similarTo (URL is the source of truth)
  const { semanticClipSearchParam } = useFilterParams();
  const similarTo = semanticClipSearchParam?.is;

  const hasAppliedImageSearchFilter = !!similarToImage || !!similarTo;

  const showViewSortingRelevance = (searchType === 'smart' && isSearchActive) || hasAppliedImageSearchFilter;
  const showExactSearchHeaders = searchType === 'keyword' && !hasAppliedImageSearchFilter;
  const similarToImageSearchAvailable = isOnAllPage && canUseSmartSearch && isAboveMediumScreen;
  const similarToSearchAvailable = canUseSmartSearch && isAboveMediumScreen;

  return {
    showViewSortingRelevance,
    showViewTypeToggleMenu: !showViewSortingRelevance,
    showExactSearchHeaders,
    isActiveImageSearch: hasAppliedImageSearchFilter,
    similarToImageSearchAvailable,
    similarToSearchAvailable,
  };
};
